import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

export default function OList({ children, colorsOrder }) {
  const classes = classNames({
    [styles.list]: true,
    [styles[colorsOrder]]: Boolean(colorsOrder)
  });

  return <ol className={classes}>{children}</ol>;
}

OList.propTypes = {
  children: PropTypes.node,
  colorsOrder: PropTypes.oneOf(['rbo'])
};
